import React, { useContext, useCallback, useMemo } from 'react';
import { Trans } from '@lingui/macro';
import { BasicData } from '@App';
import { getTextColorClass, scrollTo, isLite, getColor} from '@utils/Utils';
import ContactModal from '@components/contact/modal';

import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/pro-regular-svg-icons';

const NavBarBottom = ({ menuOpen, toggleMenu }) => {
    const { branding, unique_enquiry_url, theme, operator_tier } = useContext(BasicData);

    const colors = getColor(theme);

    const bookNow = useCallback(() => {
        if (unique_enquiry_url?.length || branding?.enquiry_url?.length) {
            unique_enquiry_url ?  window.open(unique_enquiry_url, '_blank') : window.open(branding.enquiry_url, '_blank')
        } else {
            scrollTo("enquiry-form");
        }
    }, [branding, unique_enquiry_url])

    const showEnquireButton = useMemo(() => {
        if (isLite(operator_tier)) return true;
        if (theme?.enquiry_button_label === "Hidden" || theme?.enquiry_button_label === "Hide" || !branding) return false;
        if (unique_enquiry_url && unique_enquiry_url?.length > 0) return true;
        if (branding?.enquiry_url && branding?.enquiry_url?.length > 0) return true;
        if (theme?.template_settings?.itinerary_blocks && !theme?.template_settings?.itinerary_blocks?.find((block) => block.type === "Enquiry")) return false;
        return true;
    }, [theme, branding, unique_enquiry_url, operator_tier])

    return (
        <div className={`nav-bar-bottom px-[30px] pr-md-[10px] pl-md-[20px] ${isLite(operator_tier) ? 'pr-[20px]' : ''}`} id='nav-bar-bottom'>
                <h6 className="btn-menu" onClick={toggleMenu}>
                    <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} />
                    <Trans>Menu</Trans>
                </h6>

            {(showEnquireButton) && !isLite(operator_tier) && (
                <button className={`btn ${getTextColorClass(colors.button_color)} ${isLite(operator_tier) ? 'w-sm-100 ml-auto' : ''}`} onClick={bookNow}>
                    <h6><Trans id={theme?.enquiry_button_label || "Book Now"} values={theme?.enquiry_button_label || "Book Now"} /></h6>
                </button>
            )}

            {isLite(operator_tier) && (
                (unique_enquiry_url?.length || branding?.enquiry_url?.length) ? (
                    <button className={`btn ${getTextColorClass(colors.button_color)} ${isLite(operator_tier) ? 'w-sm-100 ml-auto' : ''}`} onClick={bookNow}>
                        <h6><Trans id={theme?.enquiry_button_label || "Book Now"} values={theme?.enquiry_button_label || "Book Now"} /></h6>
                    </button>
                ) : (
                    <div className="ml-auto w-max-content">
                        <ContactModal />
                    </div>
                )
            )}
        </div>
    )
}

export default React.memo(NavBarBottom);